export default __webpack_public_path__ + "static/media/orange-coins-256.3fc3dd3a.png";